export const HIDE_TOAST = 'hideToast';
export const SHOW_TOAST = 'showToast';
export const DEFAULT_ERROR_MESSAGE =
  'Er is iets fout gegaan. Probeer het later nog eens.';
export const UPDATE_AUTH = 'updateAuth';
